import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useBatch } from "@/context/BatchContext";

export function BatchAlertSignup({ onDone }) {
  const { display } = useBatch();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError("");
    try {
      const { data } = await api.post("/batch-alerts/subscribe", { name, phone, source: "popup" });
      setDone(data.message);
      setTimeout(() => onDone?.(), 2200);
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); } finally { setSaving(false); }
  };

  if (done) return <p className="mt-6 text-sm font-bold text-[#0C4A28] bg-[#0C4A28]/10 rounded-2xl px-4 py-3" data-testid="batch-alert-success">{done}</p>;

  return (
    <form onSubmit={submit} className="mt-6 space-y-2" data-testid="batch-alert-form">
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" data-testid="batch-alert-name" className="w-full px-4 py-2.5 rounded-full border-2 border-[#1A1A1A]/10 text-sm bg-white outline-none focus:border-[#D97706]" />
      <input value={phone} onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))} inputMode="numeric" placeholder="10-digit WhatsApp number" data-testid="batch-alert-phone" className="w-full px-4 py-2.5 rounded-full border-2 border-[#1A1A1A]/10 text-sm bg-white outline-none focus:border-[#D97706]" />
      {error && <p className="text-xs font-bold text-red-500 px-1" data-testid="batch-alert-error">{error}</p>}
      <button type="submit" disabled={saving || phone.length !== 10} data-testid="batch-popup-cta" className="w-full py-3 rounded-full font-bold text-sm text-white bg-[#D97706] hover:bg-[#B45309] transition-colors disabled:opacity-50">
        {saving ? "Saving..." : display.alert_label}
      </button>
      <p className="text-[10px] text-[#1A1A1A]/40 text-center">One WhatsApp message when pizzas are back. Reply STOP anytime.</p>
    </form>
  );
}
